import { LandmarkIcon, MapPinIcon, ScrollText } from 'lucide-react'
import LawIcon from '@/public/assets/law.icon.svg'

export const documentTypeMappings = {
  clause: 'Gesetze',
  decision: 'Entscheidungen',
  rechtssatz: 'Rechtssätze',
  law: 'Gesetze',
}
export const documentTypeMappingsSingular = {
  clause: 'Gesetz',
  decision: 'Entscheidung',
  rechtssatz: 'Rechtssatz',
  law: 'Gesetz',
}

export const documentTypeFilters = {
  decision: {
    sortOptions: ['decisionDate', 'publishedDate', 'views'],
    facets: ['institution', 'decisionDate'],
  },
  rechtssatz: {
    sortOptions: ['decisionDate', 'publishedDate', 'views'],
    facets: ['institution', 'decisionDate'],
  },
  clause: {
    sortOptions: ['inEffectDate', 'outOfEffectDate', 'views'],
    facets: ['state', 'lawType', 'inEffectDate', 'outOfEffectDate'],
  },
  law: {
    sortOptions: ['inEffectDate', 'outOfEffectDate', 'views'],
    facets: ['state', 'lawType', 'inEffectDate', 'outOfEffectDate'],
  },
} satisfies Record<string, { sortOptions: Array<keyof typeof sortOptionMapppings>, facets: string[] }>

export const sortOptionMapppings = {
  inEffectDate: { name: 'Inkrafttretungsdatum', description: 'Wann das Gesetz in Kraft getreten ist.' },
  outOfEffectDate: { name: 'Außerkrafttretungsdatum', description: 'Wann das Gesetz außer Kraft getreten ist.' },
  decisionDate: { name: 'Entscheidungsdatum', description: 'Wann die Entscheidung von dem Gericht/der Behörde gefällt wurde.' },
  publishedDate: { name: 'Veröffentlichungsdatum', description: 'Wann die Entscheidung von der publizierenden Stelle veröffentlich wurde (z.B. im RIS oder Findok' },
  changedDate: { name: 'Änderungsdatum', description: 'Wann die Entscheidung das letzte Mal aktualisiert wurde.' },
  views: { name: 'Popularität', description: 'Wie oft die Entscheidung aufgerufen wurde.' },
  count: { name: 'Popularität', description: 'Wie oft die Query aufgerufen wurde.' },
  _text_match: { name: 'Relevanz', description: 'Wie relevant die Entscheidung zu Ihrer Suchanfrage ist.' },
} as const

export const facetMappings = {
  institution: {
    name: 'Institutionen',
    icon: LandmarkIcon,
  },
  state: {
    name: 'Bundesland',
    icon: MapPinIcon,
  },
  // decisionType: 'Entscheidungstyp',
  lawType: {
    name: 'Gesetzestyp',
    icon: LawIcon,
  },
  legalCategories: {
    name: 'Rechtsgebiete',
    icon: ScrollText,
  },
} as const

export const lawTypeMappings = {
  bvg: 'Bundesverfassungsgesetz',
  bg: 'Bundesgesetz',
  v: 'Verordnung',
  k: 'Kundmachung',
  l_lvg: 'Landesverfassungsgesetz',
  l_lg: 'Landesgesetz',
  l_v: 'Verordnung',
  l_k: 'Kundmachung',
  l_vereinbarung: 'Vereinbarung',
  l_beschluss: 'Beschluss',
  L_sonstiges: 'Sonstiges',
  'l_ris-information': 'RIS-Information',
  l_landtagsbeschluss: 'Landtagsbeschluss',
  l_sonstiges: 'Sonstiges',
  // l_s: 'Satzung',?
  entschl: 'Entschließung des Bundespräsidenten',
} as const

